import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Masthead } from "./components/Masthead";
import { Footer } from "./components/Footer";
import { StickyCTA } from "./components/StickyCTA";
import { CookieConsent } from "./components/CookieConsent";
import Home from "./pages/Home";
import Research from "./pages/Research";
import Prepare from "./pages/Prepare";
import OurStory from "./pages/OurStory";
import TheScience from "./pages/TheScience";
import Contact from "./pages/Contact";
import Quiz from "./pages/Quiz";
import { Privacy, Terms, Cookies } from "./pages/Legal";
import NotFound from "./pages/NotFound";

/* Scroll to top on route change; honour #hash anchors. */
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

/* Gentle parallax for elements with [data-plx]. */
const Parallax = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      document.querySelectorAll("[data-plx]").forEach((el) => {
        const rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const speed = parseFloat(el.getAttribute("data-plx")) || 0.15;
        const offset = (rect.top + rect.height / 2 - vh / 2) * speed;
        el.style.transform = `translateY(${offset.toFixed(1)}px)`;
      });
    };
    const onScroll = () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Parallax />
      <Masthead />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/research" element={<Research />} />
        <Route path="/prepare" element={<Prepare />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/the-science" element={<TheScience />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <StickyCTA />
      <CookieConsent />
    </BrowserRouter>
  );
}
